// extracted by mini-css-extract-plugin
module.exports = {"item":"_2FGk1","flat-item":"_1vP-O","flatItem":"_1vP-O","slim-item":"_23Bm_","slimItem":"_23Bm_","collapse-top-first":"_3cegj","collapseTopFirst":"_3cegj"};